module.exports = __webpack_public_path__ + "static/media/clock.a128dea9.png";